<div class="card card-custom">
    <!-- Header -->
    <div class="card-header align-items-center">
        <div class="card-title">
            <h3 class="card-label">Lista clienti</h3>
        </div>
        <div class="action-btn">
            <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4" routerLink="/sistemerp/clienti/adaugare">
                Adauga client <span class="fa fa-plus-circle"></span>
            </a>
        </div>
    </div>
    <!--begin::Body-->



    <div class="card-body py-0 pt-5">
        <form #searchForm="ngForm" class="filterForm">
            <div class="filters-section">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="card card-body">
                            <div class="input-group mb-3">
                                <ng-select2 [(ngModel)]="selectCompany"
                                            *ngIf="dataLoaded"
                                            [data]=clientsNameArray
                                            [options]="singleSelect"
                                            [allowClear]="true"
                                            class="select2-input"
                                            name="companyName"
                                            placeholder="Tasteaza numele sau CUI-ul companiei...">

                                </ng-select2>
                                <div class="input-group-append">
                                    <button class="btn btn-light-primary"
                                            type="button"
                                            (click)="goToCompany()">
                                        Vezi compania
                                        <span class="fa fa-arrow-circle-right"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 pt-5">
                    <div class="row">
                        <button class="btn btn-light-primary col-lg-12" type="button" data-toggle="collapse" data-target="#collapseSearch" aria-expanded="false" aria-controls="collapseExample">
                            Cautare avansata
                            <span class="fa fa-sliders-h"></span>
                        </button>
                        <div class="collapse" id="collapseSearch">
                            <div class="card card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Domeniu</label>
                                            <ng-select2 [data]="domainsArrayValues"
                                                        [options]="domainOptions"
                                                        [(ngModel)]="activitySector"
                                                        [placeholder]="' -- Alege o optiune -- '"
                                                        [allowClear]=true
                                                        name="activitySector"
                                                        (valueChanged)="changeDomain($event)">
                                            </ng-select2>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Subdomeniu</label>
                                            <ng-select2 [data]="subdomains"
                                                        [options]="subDomainOptions"
                                                        [(ngModel)]="companyActivitySubSector"
                                                        [allowClear]=true
                                                        [placeholder]="' -- Alege o optiune -- '"
                                                        name="companyActivitySubSector">
                                            </ng-select2>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="">
                                            <label>Tip companie</label>
                                            <select class="form-control form-control-md" [(ngModel)]="companyType">
                                                <option value="">-- Alege o optiune -- </option>
                                                <option value="entrepreneurial">Antreprenoriala</option>
                                                <option value="multinational">Multinationala</option>
                                                <option value="stat">De stat</option>
                                                <option value="mixed">Mixta</option>

                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Nivel companie</label>
                                            <select class="form-control form-control-md" [(ngModel)]="companyEmployeesLevel">
                                                <option value="">-- Alege o optiune -- </option>
                                                <option value="micro">Micro (1-9 angajati)</option>
                                                <option value="small">Mica (10-49 angajati)</option>
                                                <option value="medium">Medie (50-249 angajati)</option>
                                                <option value="big">Mare (peste 250 angajati)</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Rating</label>
                                            <input type="number" min="1" max="5" class="form-control form-control-md" [(ngModel)]="rating">
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-md-6 text-right form-group">
                                        <button class="btn btn-light-danger font-weight-bold btn-block"
                                                type="button"
                                                (click)="resetForm(searchForm);">
                                            <span class="fa fa-search"></span> Resetare
                                        </button>
                                    </div>
                                    <div class="col-md-6 text-right form-group">
                                        <button class="btn btn-light-primary font-weight-bold btn-block"
                                                type="button"
                                                (click)="companiesCall();">
                                            <span class="fa fa-search"></span> Cautare
                                        </button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </form>




        <div class="col-lg-12 pt-3">
            <hr>
            <div>
                <label class="mb-0">Nr. total de rezultate: {{totalElements}}</label>
            </div>
            <hr>
            <div class="row mt-5 mb-5">
                <div class="col-md-3">
                    <div class="d-flex align-items-center">
                        <label class="mr-3 mb-0">Rezultate: </label>
                        <select (change)="onSizeChange($event)" class="form-control">
                            <option *ngFor="let size of pageSizes" [ngValue]="size">
                                {{ size }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 offset-3">
                    <div class="d-flex align-items-center justify-content-end">
                        <div class="col-md-6 d-flex align-items-center">
                            <label class="mr-3 mb-0">Sortare: </label>
                            <select (change)="onSortChange($event)" class="form-control">
                                <option [ngValue]="undefined"> -- Alege -- </option>
                                <option *ngFor="let item of sortingValues" value="{{item.value}}">{{item.name}}</option>

                            </select>
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                            <label class="mr-3 mb-0">Ordonare: </label>
                            <select (change)="onOrderChange($event)" class="form-control">
                                <option [ngValue]="undefined"> -- Alege -- </option>
                                <option value="asc">Ascendent</option>
                                <option value="desc">Descendent</option>
                            </select>
                        </div>

                    </div>
                </div>

            </div>
            <hr>

            <!--begin::Table-->
            <div class="table-responsive mt-3">
                <table
                        class="table table-head-custom table-vertical-center"
                        id="kt_advance_table_widget_1"
                >
                    <thead>
                    <tr class="text-left">
                        <th class="pr-0 pl-0" style="min-width: 200px">Nume companie</th>
                        <th style="min-width: 150px">Cod fiscal</th>
                        <th style="min-width: 150px">Domeniu</th>
                        <th style="min-width: 150px">Subdomenii</th>
                        <th style="min-width: 150px">Tip</th>
                        <th>Nivel</th>
                        <th>Rating</th>
                        <th>Sursa</th>
                        <th class="pr-0 text-right" style="min-width: 150px">Actiuni</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let company of filteredCompanies.content">
                        <td class="pl-0">
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["companyName"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["fiscalCode"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["activitySector"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["companyActivitySubSector"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["companyType"] | enumTransform}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["companyEmployeesLevel"] | enumTransform}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{company["rating"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg blackListStatus mb-0">
                                <span *ngIf="company['clientOwnerId'] !== 'none'" class="btn btn-light-success">JobBoard</span>
                                <span *ngIf="company['clientOwnerId'] === 'none'"  class="btn btn-light-primary">CRM</span>
                            </p>
                        </td>
                        <td class="pr-0 text-right">
                            <a class="btn btn-icon btn-success btn-hover-primary btn-sm"
                               routerLink="/sistemerp/clienti/vizualizare/{{company['id']}}" ngbTooltip="Vezi" placement="bottom">
                                <i class="icofont-eye-alt"></i>
                            </a>
                            <a class="btn btn-icon btn-info btn-hover-primary btn-sm mx-3"
                               routerLink="/sistemerp/clienti/editare/{{company['id']}}" ngbTooltip="Editeaza" placement="bottom">
                                <i class="icofont-edit"></i>
                            </a>
                        </td>

                    </tr>
                    </tbody>
                </table>

            </div>
            <!--end::Table-->
        </div>
        <div class="col-md-12 mt-5">
            <ngb-pagination class="d-flex justify-content-center"
                            [(page)]="page"
                            [pageSize]="size"
                            [maxSize]="5"
                            [collectionSize]="totalElements"
                            (pageChange)="onPageChange(page)"
            ></ngb-pagination>
        </div>
        <!--end::Body-->
    </div>
